import React, { FC, useState } from "react";
import AdjustmentsMetersTable from "./AdjustmentsPageComponents/AdjustmentsMetersTable";
import { IonButton } from "@ionic/react";
import DegreeDaysRegressionSettings from "./AdjustmentsPageComponents/DegreeDaysRegressionSettings";
import useToggle from "../../../utils/useToggle";
import DegreeDaysRegression from "./AdjustmentsPageComponents/DegreeDaysRegression";


interface IProps {
    id:string | null
};

const Adjustments:FC<IProps> = (props) => {
    const [settings, toggleSettings] = useToggle(true);
    const [regressionMeter, setRegressionMeter] = useState<any>(null)
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';


    return <div>
        <div style={{ textAlign: "center",paddingBottom:'1em' }}>
            <h2 className={newUI?'text-dark-blue':''}>Baseline Adjustments</h2>
            <div>Baseline Adjustments are done per meter. Select the desired method for each meter then run the cost avoidance calculations.</div>
            <IonButton color={'tertiary'} onClick={()=>toggleSettings()}>Settings</IonButton>
            <DegreeDaysRegressionSettings hidden={settings} id = {props.id}/>
        </div>
        <div>
            <div><AdjustmentsMetersTable id = {props.id} setRegressionMeter={setRegressionMeter}/> </div>
        </div>
        {regressionMeter ? 
        <div hidden={regressionMeter===''}>
            <DegreeDaysRegression id={regressionMeter[0]} name={regressionMeter[1]}/>
        </div> : null}
    </div>
};

export default Adjustments;